<style lang="scss" scoped>
.center-box {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.center-box__inner {
  width: 100%;
  max-width: 600px;
}
</style>

<template>
  <div class="center-box">
    <div class="center-box__inner">
      <slot></slot>
    </div>
  </div>
</template>

<script lang="babel">
export default {};
</script>
